export const API_URL = "https://z14cer9v4f.execute-api.ap-south-1.amazonaws.com/prod";
export const API_TOKEN = "iMkDxTzkxyaF8NvgBUoIXVsZQ7AGaOI6J0rZWOsh";
